<template>
  <validation-observer ref="dataForm">
    <b-row>
      <!-- <b-col md="12">
         <b-form-group
          id="input-group-27"
          :label="$t('addwizard.name_title')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="intake"
            vid="intake"
            rules="required"
          >
          <b-form-select
            v-model="newItem.Title"
            :placeholder="$t('addwizard.name_title')"
          >
            <option value="" disabled>اختيار</option>
            <option value="L001">السيد</option>
            <option value="P020">السيدة</option>
            <option value="P019">الآنسة</option>
          </b-form-select>
          <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider> </b-form-group>
      </b-col> -->
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="input-group-2"
          :label="$t('addwizard.fullname')"
          label-for="input-2"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="fullname"
            vid="fullname"
            rules="required"
            :custom-messages="{ required: ' الاسم مطلوب' }"

          >
            <b-form-input
              id="input-2"
              v-model="newItem.fullname"
              type="text"
              :placeholder="$t('addwizard.fullname')"
            >
            </b-form-input>

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="input-group-2"
          :label="$t('addwizard.ArabicName')"
          label-for="input-2"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="ArabicName"
            vid="ArabicName"
            rules="required"
            :custom-messages="{ required: ' الاسم باللغة العربية مطلوب' }"

          >
            <b-form-input
              id="input-2"
              v-model="newItem.ArabicName"
              type="text"
              :placeholder="$t('addwizard.ArabicName')"
            >
            </b-form-input>

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="input-group-2"
          :label="$t('addwizard.BirthDate')"
          label-for="input-2"
          label-cols-md="3"
          :custom-messages="{ required: ' تاريخ الميلاد  مطلوب' }"
        >
          <validation-provider
            #default="{ errors }"
            name="BirthDate"
            vid="BirthDate"
            rules="required"
          >
            <flat-pickr
              v-model="newItem.BirthDate"
              class="form-control"
              :config="{ dateFormat: 'm/d/Y' }"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="gender"
          :label="$t('addwizard.gender')"
          label-for="gender"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="gender"
            vid="gender"
            rules="required"
            :custom-messages="{ required: ' الجنس مطلوب' }"

          >
            <div class="demo-inline-spacing">
              <b-form-radio
                v-model="newItem.gender"
                name="gender-radios"
                value="M"
              >
                {{ $t("addwizard.male") }}
              </b-form-radio>
              <b-form-radio
                v-model="newItem.gender"
                name="gender-radios"
                value="F"
              >
                {{ $t("addwizard.female") }}
              </b-form-radio>
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- <b-col lg="12">
        <b-form-group
          id="input-group-photo_of_student"
          :label="$t('addwizard.photo_of_student')"
          label-for="input-photo_of_student"
          label-cols-md="3"
        >
          <b-form-file
            v-model="newItem.PHOTO"
            accept="image/*"
            :placeholder="$t('addwizard.photo_of_student')"
          />
        </b-form-group>
      </b-col> -->
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.Race')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="Race"
            vid="Race"
            rules="required"
            :custom-messages="{ required: ' العرق   مطلوب' }"

          >
            <v-select
              v-model="newItem.Race"
              label="NameAr"
              :options="race"
              :reduce="(country) => country.MoheCode"
              :placeholder="$t('addwizard.Race')"
              dir="rtl"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="input-group-27"
          :label="$t('addwizard.Religion')"
          label-for="input-27"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="Religion"
            vid="Religion"
            rules="required"
            :custom-messages="{ required: ' الديانة   مطلوبة' }"
          >
            <v-select
              v-model="newItem.Religion"
              label="NameAr"
              :options="religion"
              :reduce="(country) => country.MoheCode"
              :placeholder="$t('addwizard.Religion')"
              dir="rtl"

            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="Citizenship"
          :label="$t('addwizard.Citizenship')"
          label-for="Citizenship"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="Citizenship"
            vid="Citizenship"
            rules="required"
            :custom-messages="{ required: ' بلد المنشاً   مطلوبة' }"
          >
            <v-select
              v-model="newItem.Citizenship"
              label="NameAr"
              :options="citizenship"
              :reduce="(country) => country.Code"
              :placeholder="$t('addwizard.Citizenship')"
              dir="rtl"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="input-group-ID_Card"
          :label="$t('addwizard.ID_Card')"
          label-for="ID_Card"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="ID_Card"
            vid="ID_Card"
            rules="required"
            :custom-messages="{ required: ' رقم الهوية   مطلوب' }"

          >
            <b-form-input
              id="ID_Card"
              v-model="newItem.ID_Card"
              type="text"
              :placeholder="$t('addwizard.ID_Card')"
            >
            </b-form-input>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <!-- .first_name -->
        <b-form-group
          id="Citizenship"
          :label="$t('addwizard.IDPassportIssuedCountry')"
          label-for="Citizenship"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            name="IDPassportIssuedCountry"
            vid="IDPassportIssuedCountry"
            rules="required"
            :custom-messages="{ required: ' تادواة المصدرة لجواز السفر  مطلوبة' }"

          >
            <v-select
              v-model="newItem.IDPassportIssuedCountry"
              :options="citizenship"
              label="NameAr"
              :reduce="(country) => country.Code"
              :placeholder="$t('addwizard.IDPassportIssuedCountry')"
              dir="rtl"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- <b-col lg="12">
        <b-form-group
          id="input-group-IDCARD"
          :label="$t('addwizard.IDCARD')"
          label-for="input-IDCARD"
          label-cols-md="3"
        >
          <b-form-file
            v-model="newItem.IDCARD"
            accept="application/pdf,image/*"
            :placeholder="$t('addwizard.IDCARD')"
          />
        </b-form-group>
      </b-col> -->
    </b-row>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import mediuEduController from "@/Controllers/MediuEduController";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Auth from "@/Apis/Auth";

export default {
  components: {
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    required,
  },

  data() {
    return {
      newItem: {},
      citizenship: [],
      religion: [],
      race: [],
      options: { first_faculty: [], second_faculty: [] },
    };
  },
  async created() {
    const user = Auth.USER;
     this.newItem.fullname = user.full_name_en;
    this.newItem.ArabicName = user.full_name;
    var dateObject = new Date(user.birth_date);
    let d =
      dateObject.getMonth() +
      1 +
      "/" +
      dateObject.getDate() +
      "/" +
      dateObject.getFullYear();

    this.newItem.BirthDate = d;
    this.newItem.gender = "F";
    if (user.gender == "male") {
      this.newItem.gender = "M";
    }
    //  this.newItem.fullname=user.full_name_en
    //  this.newItem.fullname=user.full_name_en
    //  this.newItem.fullname=user.full_name_en
     const ct = new mediuEduController();
    this.religion = await ct.GetReligion();
    //  this.newItem.Citizenship=
    this.race = await ct.GetRace();

    this.citizenship = await ct.GetCitizenship();
  },
  methods: {
    selectFaculty(type) {
      console.log(this.options);
      this.options[type] = this.coursesOptions.filter(
        (a) => a.faculty == this.newItem[type]
      );
    },
    async returnData() {
      const isValid = await this.$refs.dataForm.validate();
      if (!isValid) {
        return { valid: false };
      }
      return { valid: true, data: this.newItem };
    },
  },
};
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>